import { Piece } from './piece.model';

export class PhotoLieu {
    id: number;
    name: string;
    path: string;
    piece_id: number;
    dossier_intervention_id: number;
    file: File;
    created_at: string;

    public constructor(init?: Partial<PhotoLieu>) {
      Object.assign(this, init);
    }
  }
